<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    light: {
      type: Boolean,
      default: false,
      required: false,
    },
  });

  const classes = computed(() => ({
    'credere-loading': true,
    'variant--light': props.light,
  }));
</script>

<template>
  <span :class="classes">
    <span
      v-for="i in 3"
      :key="i"
      class="credere-loading-bullet"
    />
  </span>
</template>

<style lang="scss">
  .credere-loading {
    --loading-bullet: var(--token-spacing-mini);
    --loading-margin: var(--loading-bullet);

    height: calc(var(--loading-bullet) * 2);
    position: relative;
    width: calc(var(--loading-bullet) * 3 + var(--loading-margin) * 2);
  }

  @keyframes credere-loading {
    0% { transform: translateY(calc(var(--loading-bullet) / -2)); opacity: 1; }
    50% { transform: translateY(var(--loading-bullet) / 2); opacity: 0.5; }
    100% { transform: translateY(calc(var(--loading-bullet) / -2)); opacity: 1; }
  }

  .credere-loading-bullet {
    --background-color: var(--token-color-neutral-primary);
    --border-radius: 100%;

    animation: credere-loading 1s infinite;
    height: var(--loading-bullet);
    left: 0;
    position: absolute;
    top: calc(50% - var(--loading-bullet) / 4);
    width: var(--loading-bullet);

    .variant--light & {
      --background-color: var(--token-color-constant-light);
    }

    @for $i from 0 through 2 {
      &:nth-child(#{$i}) {
        animation-delay: $i * 0.2s;
        left: calc((var(--loading-bullet) + var(--loading-margin)) * $i);
      }
    }
  }
</style>
